import { connect } from 'react-redux';

import { trackCatalogExplore } from 'app/actions/AnalyticsGa4Actions';

import TagList from './TagList';

export default connect(null, {
  trackCatalogExplore
})(TagList);
